export default __webpack_public_path__ + "static/media/bump_compressed.9b1c962b.png";